import Defaults from './Defaults';
import InlineTemplates from './InlineTemplates';
import Geolocation from './Geolocation';
import {MailChimpForm} from './MailChimpAjaxForm';
import Utils from './Utils';
import ScrollLinks from './ScrollLinks';
import Lightbox from './Lightbox';
import MediaHelper from './MediaHelper';
import MovieHeaderVideo from './MovieHeaderVideo';
import Menu from './Menu';
import Session from './Session';
import Links from './Links';
import FiltersLocker from './FiltersLocker';
import SearchByFiltersCollection from "./SearchByFiltersCollection";
import PageFilter from "./Filters/PageFilter";
import CinemaDistances from "./Filters/CinemaDistances";

export default function()
{
    /**
     * Same reference as window.MrMovie
     * @type {Object}
     */
    const self = this;

    /**
     * Initialize objects
     * @return {void}
     */
    self.init = () => {
        MrMovie.defaults = new Defaults();
        MrMovie.utils = new Utils();
        MrMovie.geolocation = new Geolocation();
        MrMovie.mediaHelper = new MediaHelper();
        MrMovie.session = new Session();
        MrMovie.filtersLocker = new FiltersLocker();
        MrMovie.searchByFiltersCollection = new SearchByFiltersCollection();

        if(window.location.pathname.includes("/bioscopen")) {
            MrMovie.pageFilter = new PageFilter('cinema-location-filter', '/ajax/cinema-page-filter-content');
        } else if(window.location.pathname.includes("/film/")) {
            MrMovie.pageFilter = new PageFilter('movie-calendar-filter', '/ajax/movie-calendar-performances');
        } else {
            MrMovie.pageFilter = new PageFilter('movie-location-filter', '/ajax/movie-page-filter-content');
        }

        MrMovie.cinemaDistances = new CinemaDistances();


        const mailChimpForm = new MailChimpForm();
        mailChimpForm.captureSubmit();

        //MrMovie.inlineTemplates = new InlineTemplates();
        //MrMovie.inlineTemplates.register();

        $(document).on('vue-ready', () => {
            const menu = new Menu();
            menu.enableScrollStyling();

            const lightbox = new Lightbox();
            lightbox.setLinkSelector('.movie-single-description-still-link');
            lightbox.enable();

            const scrollLinks = new ScrollLinks('.scroll-link');
            scrollLinks.setHeadroom(30);
            scrollLinks.enable();

            const movieHeaderVideo = new MovieHeaderVideo();
            movieHeaderVideo.enablePlaying();
            movieHeaderVideo.enableFullScreenButton();

            const links = new Links();
            links.enableExternalLinks();

            MrMovie.pageFilter.init();
            //MrMovie.locationFilter.applyActiveFilters();
        });
    };
}



// WEBPACK FOOTER //
// ./resources/js/MrMovie/Init.js